import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

const TIER_LABEL = { bronze: 'Bronze', silver: 'Argent', gold: 'Or', platinum: 'Platine' };

export function BadgeCard({ b }) {
  return (
    <div className={`badge-card tier-${b.tier}${b.unlocked ? ' unlocked' : ''}`}>
      <div className="badge-icon">{b.unlocked ? b.icon : '🔒'}</div>
      <div className="badge-info">
        <div className="badge-title">{b.title}</div>
        <div className="muted small">{b.desc}</div>
        {b.unlocked ? (
          <div className="badge-date">✔ Obtenu le {new Date(b.unlocked_at).toLocaleDateString('fr-FR')} · +{b.points} pts</div>
        ) : (
          <>
            <div className="progress-bar"><div className="progress-fill" style={{ width: `${Math.round(b.progress * 100)}%` }} /></div>
            <div className="muted small">{b.current.toLocaleString('fr-FR')} / {b.target.toLocaleString('fr-FR')}</div>
          </>
        )}
      </div>
      <span className="tier-tag">{TIER_LABEL[b.tier]}</span>
    </div>
  );
}

export default function Trophies() {
  const { data, isLoading } = useQuery({ queryKey: ['achievements'], queryFn: api.getAchievements });
  if (isLoading || !data) return <div className="loading"><div className="spinner" />Chargement…</div>;

  const { badges, level } = data;
  const unlocked = badges.filter((b) => b.unlocked).length;
  const span = level.next_at ? level.next_at - level.current_at : 1;
  const pct = level.next_at ? Math.min(100, ((level.points - level.current_at) / span) * 100) : 100;
  const categories = [...new Set(badges.map((b) => b.category))];

  return (
    <div>
      <h1 className="page-title">Trophées &amp; badges</h1>
      <p className="page-subtitle">{unlocked} / {badges.length} badges débloqués</p>

      <div className="card level-card">
        <div className="level-head">
          <div className="level-badge">{level.index}</div>
          <div>
            <div className="level-name">{level.name}</div>
            <div className="muted small">{level.points} points{level.next_at ? ` · prochain niveau « ${level.next_name} » à ${level.next_at} pts` : ' · niveau maximum'}</div>
          </div>
        </div>
        <div className="progress-bar"><div className="progress-fill" style={{ width: `${pct}%` }} /></div>
      </div>

      {categories.map((cat) => (
        <section key={cat}>
          <h2 className="section-title">{cat}</h2>
          <div className="badge-grid">
            {badges.filter((b) => b.category === cat).map((b) => <BadgeCard key={b.id} b={b} />)}
          </div>
        </section>
      ))}
    </div>
  );
}
